import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'company-Information',
    templateUrl: './companyInformation.component.html',
    styleUrls: ['./companyInformation.component.css'],
    standalone: false
})
export class companyInformation implements OnInit {
constructor() { }

ngOnInit(): void {
}
}